<template>
  <div>
    <quill-editor ref="myQuillEditor" v-model="content" :options="editorOption" />
  </div>
</template>

<script>
import Quill from 'quill';
import { quillEditor } from 'vue-quill-editor';
import ImageUploader from 'quill-image-uploader';
import divider from 'quill-divider';

Quill.register(divider);
Quill.register('modules/imageUploader', ImageUploader);

export default {
  name: 'Quill',
  components: {
    QuillEditor: quillEditor,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    content: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      editorOption: {
        placeholder: this.placeholder,
        modules: {
          imageUploader: {
            upload: this.uploadImage,
          },
          divider: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'divider'],
          ],
        },
      },
    };
  },
  methods: {
    async uploadImage(file) {
      const loading = this.$buefy.loading.open();

      try {
        const { url } = await this.$imagekit.upload({
          file,
          fileName: file.name,
        });

        return url;
      } catch (e) {
        this.$buefy.snackbar.open({
          message: this.$t('quill.cannot.upload.image'),
          type: 'is-danger',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 10000,
        });

        this.$sentry.captureException(e);

        throw e;
      } finally {
        loading.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

/deep/ .ql-container {
  font-family: $family-primary;

  .quill-hr hr {
    background: $primary;
  }
}
</style>
